










































































import Vue from 'vue';

export default Vue.extend({
  'name': 'AdminMarketOverview',
  data () {
    return {
      'loading': false,
      'error': null as string | null,
      'data': null as any
    };
  },
  'methods': {
    refresh () {
      this.loading = true;
      this.error = null;
      this.axios.get('admin/market-overview')
        .then((res: any) => { this.data = res.data.result || null; })
        .catch((e: any) => { this.error = e?.response?.data?.message || 'Failed to load.'; })
        .finally(() => { this.loading = false; });
    },
    exportCsv () {
      if (!this.data) return;
      const lines: string[] = [];
      lines.push('section,key1,key2,count');
      (this.data.byMakeModel || []).forEach((r: any) => lines.push(`make_model,"${r.make}","${r.model}",${r.count}`));
      (this.data.byDealer || []).forEach((r: any) => lines.push(`dealer,"${r.dealerName}",,${r.count}`));
      (this.data.byState || []).forEach((r: any) => lines.push(`state,"${r.state}",,${r.count}`));
      const blob = new Blob([lines.join('\n')], { 'type': 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `market-overview-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  mounted () { this.refresh(); }
});
